// TODO: These will eventually replace filter-group-configurations.ts
import { SortByMethod, SortTypes } from '@interfaces/models/catalogFilter';
import { ElasticSearchResponse } from '@interfaces/api/responses/elasticSearch';
import { ElasticSearchFacetsFields, ElasticSearchFilterKeys } from '@interfaces/models/elasticSearch';

enum UniverseIds {
  Women = '1',
  Men = '2',
  Kids = '3',
}

export interface HotFilterGroupConfiguration {
  type: string;

  /**
   * Filter label.
   */
  label: string;

  criteria?: (facets: ElasticSearchResponse['facets']['fields']) => boolean;

  /**
   * Name of the attributes for faceting.
   */
  facet?: ElasticSearchFacetsFields;

  /**
   * Whether filter component should display an input to search for facet values.
   */
  isSearchable?: boolean;

  /**
   * The label of the search input placeholder.
   */
  searchPlaceholder?: string;

  /**
   * Set type order that filter items are shown
   * ex: ['name:asc']
   */
  sortBy?: Partial<SortTypes> | SortByMethod;

  /**
   * Label of the item when filter has one option item.
   */
  itemText?: string[];

  /**
   * Filter name to send on search API
   */
  filter?: ElasticSearchFilterKeys;

  /**
   * Universe ID used for size filters
   */
  universeId?: UniverseIds;
}

export enum HotFilterTypes {
  CATEGORY = 'category',
  MATERIAL = 'material',
  PRICE = 'price',
  SIZE = 'size',
  ITEM = 'item',
  COLOR_SWATCH = 'color-swatch',
  TEXT_SWATCH = 'text-swatch',
  BOOLEAN = 'boolean',
}

const categoryFilterFacetFields = ['universe', 'categoryLvl0', 'categoryLvl1', 'categoryLvl2'] as const;

const materialFilterFacetFields = ['materialLvl0', 'materialLvl1'] as const;

export const sizeHotfilterGroupConfigurations: HotFilterGroupConfiguration[] = [
  {
    // "SIZE 1": "Women’s Size"
    // EXCEPTION: international (US) and JP should be sorted by ClothingSize
    type: HotFilterTypes.TEXT_SWATCH,
    label: 'CATALOG.FILTERS.SIZE.1',
    facet: 'size1',
    sortBy: {
      default: 'sortByNumericValue',
      US: 'sortClothingSizes',
      KR: 'sortClothingSizes',
    },
    filter: 'size1',
    universeId: UniverseIds.Women,
  },
  {
    // "SIZE 2": "Jean size" (women)
    type: HotFilterTypes.TEXT_SWATCH,
    label: 'CATALOG.FILTERS.SIZE.2',
    facet: 'size2',
    sortBy: 'sortByNumericValue',
    filter: 'size2',
    universeId: UniverseIds.Women,
  },
  {
    // "SIZE 3": "Women’s shoe size"
    type: HotFilterTypes.TEXT_SWATCH,
    label: 'CATALOG.FILTERS.SIZE.3',
    facet: 'size3',
    sortBy: 'sortByNumericValue',
    filter: 'size3',
    universeId: UniverseIds.Women,
  },
  {
    // "SIZE 4": "Men’s shoe size"
    type: HotFilterTypes.TEXT_SWATCH,
    label: 'CATALOG.FILTERS.SIZE.4',
    facet: 'size4',
    sortBy: 'sortByNumericValue',
    filter: 'size4',
    universeId: UniverseIds.Men,
  },
  {
    // "SIZE 5": "Jean size" (men)
    type: HotFilterTypes.TEXT_SWATCH,
    label: 'CATALOG.FILTERS.SIZE.5',
    facet: 'size5',
    sortBy: 'sortByNumericValue',
    filter: 'size5',
    universeId: UniverseIds.Men,
  },
  {
    // "SIZE 6": "Child’s shoe size"
    type: HotFilterTypes.TEXT_SWATCH,
    label: 'CATALOG.FILTERS.SIZE.6',
    facet: 'size6',
    sortBy: 'sortByNumericValue',
    filter: 'size6',
    universeId: UniverseIds.Kids,
  },
  {
    // "SIZE 7": "Accessories size"
    type: HotFilterTypes.TEXT_SWATCH,
    label: 'CATALOG.FILTERS.SIZE.7',
    facet: 'size7',
    sortBy: 'asc',
    filter: 'size7',
    universeId: UniverseIds.Women,
  },
  {
    // "SIZE 8": "Bra size"
    type: HotFilterTypes.TEXT_SWATCH,
    label: 'CATALOG.FILTERS.SIZE.8',
    facet: 'size8',
    sortBy: 'sortByNumericValue',
    filter: 'size8',
    universeId: UniverseIds.Women,
  },
  {
    // "SIZE 9": "Accessories size"
    type: HotFilterTypes.TEXT_SWATCH,
    label: 'CATALOG.FILTERS.SIZE.9',
    facet: 'size9',
    sortBy: 'sortById',
    filter: 'size9',
    universeId: UniverseIds.Women,
  },
  {
    // "SIZE 10": "Men’s size"
    // EXCEPTION: KR should be sorted by NumericValue - NOT TRUE! - remains sorted by ClothingSize
    type: HotFilterTypes.TEXT_SWATCH,
    label: 'CATALOG.FILTERS.SIZE.10',
    facet: 'size10',
    sortBy: 'sortClothingSizes',
    filter: 'size10',
    universeId: UniverseIds.Men,
  },
  {
    // "SIZE 11": "Child’s size"
    type: HotFilterTypes.TEXT_SWATCH,
    label: 'CATALOG.FILTERS.SIZE.11',
    facet: 'size11',
    sortBy: 'sortByNumericValue',
    filter: 'size11',
    universeId: UniverseIds.Kids,
  },
  {
    // "SIZE 12": "Waist measurement"/"Belt size" (women)
    // EXCEPTION: international (US) should be sorted by ClothingSize
    type: HotFilterTypes.TEXT_SWATCH,
    label: 'CATALOG.FILTERS.SIZE.12',
    facet: 'size12',
    sortBy: {
      default: 'sortByNumericValue',
      US: 'sortClothingSizes',
    },
    filter: 'size12',
    universeId: UniverseIds.Women,
  },
  {
    // "SIZE 13": "Glove size" (women)
    type: HotFilterTypes.TEXT_SWATCH,
    label: 'CATALOG.FILTERS.SIZE.13',
    facet: 'size13',
    sortBy: 'sortClothingSizes',
    filter: 'size13',
    universeId: UniverseIds.Women,
  },
  {
    // "SIZE 14": "Hat size" (women)
    type: HotFilterTypes.TEXT_SWATCH,
    label: 'CATALOG.FILTERS.SIZE.14',
    facet: 'size14',
    sortBy: 'asc',
    filter: 'size14',
    universeId: UniverseIds.Women,
  },
  {
    // "SIZE 15": "Ring size"
    type: HotFilterTypes.TEXT_SWATCH,
    label: 'CATALOG.FILTERS.SIZE.15',
    facet: 'size15',
    sortBy: 'sortByNumericValue',
    filter: 'size15',
    universeId: UniverseIds.Women,
  },
  {
    // "SIZE 16": "Waist measurement"/ "Belt size" (men)
    type: HotFilterTypes.TEXT_SWATCH,
    label: 'CATALOG.FILTERS.SIZE.16',
    facet: 'size16',
    sortBy: 'sortByNumericValue',
    filter: 'size16',
    universeId: UniverseIds.Men,
  },
  {
    // "SIZE 17": "Glove size" (men)
    type: HotFilterTypes.TEXT_SWATCH,
    label: 'CATALOG.FILTERS.SIZE.17',
    facet: 'size17',
    sortBy: 'sortClothingSizes',
    filter: 'size17',
    universeId: UniverseIds.Men,
  },
  {
    // "SIZE 18": "Hat size" (men)
    type: HotFilterTypes.TEXT_SWATCH,
    label: 'CATALOG.FILTERS.SIZE.18',
    facet: 'size18',
    sortBy: 'asc',
    filter: 'size18',
    universeId: UniverseIds.Men,
  },
  {
    // "SIZE 19": "Suit size"
    type: HotFilterTypes.TEXT_SWATCH,
    label: 'CATALOG.FILTERS.SIZE.19',
    facet: 'size19',
    sortBy: 'sortByNumericValue',
    filter: 'size19',
    universeId: UniverseIds.Men,
  },
  {
    // "SIZE 20": "Shirt size"
    // EXCEPTION: international (US), JP, KR (wrong data in spreadsheet) should be sorted by ClothingSize
    type: HotFilterTypes.TEXT_SWATCH,
    label: 'CATALOG.FILTERS.SIZE.20',
    facet: 'size20',
    sortBy: {
      default: 'sortByNumericValue',
      US: 'sortClothingSizes',
      KR: 'sortClothingSizes',
    },
    filter: 'size20',
    universeId: UniverseIds.Men,
  },
  {
    // "SIZE 21": "Trousers size"
    // EXCEPTION: KR should be sorted by NumericValue
    type: HotFilterTypes.TEXT_SWATCH,
    label: 'CATALOG.FILTERS.SIZE.21',
    facet: 'size21',
    sortBy: {
      default: 'sortClothingSizes',
      US: 'sortClothingSizes',
      KR: 'sortClothingSizes',
    },
    filter: 'size21',
    universeId: UniverseIds.Men,
  },
  {
    // "SIZE 22": "Swimwear size"
    // EXCEPTION: international (US) and JP, KR should be sorted by ClothingSize
    type: HotFilterTypes.TEXT_SWATCH,
    label: 'CATALOG.FILTERS.SIZE.22',
    facet: 'size22',
    sortBy: {
      default: 'sortByNumericValue',
      US: 'sortClothingSizes',
      KR: 'sortClothingSizes',
    },
    filter: 'size22',
    universeId: UniverseIds.Women,
  },
  {
    //  "SIZE 23": "Polo size"
    type: HotFilterTypes.TEXT_SWATCH,
    label: 'CATALOG.FILTERS.SIZE.23',
    facet: 'size23',
    sortBy: 'sortClothingSizes',
    filter: 'size23',
    universeId: UniverseIds.Women,
  },
];

const booleanFacetCriteria = (
  facets: ElasticSearchResponse['facets']['fields'],
  facetName: ElasticSearchFacetsFields,
) => {
  if (!facets[facetName]) {
    return false;
  }
  return facets[facetName].some((facet) => facet.id === '1');
};

export const sizeHotfilterFacetFields = sizeHotfilterGroupConfigurations.map(
  (filterGroupConfiguration) => filterGroupConfiguration.facet,
);

export const hotfilterGroupConfigurations: HotFilterGroupConfiguration[] = [
  {
    type: HotFilterTypes.BOOLEAN,
    label: 'CATALOG.FILTERS.TAX_FREE',
    facet: 'dutyFree',
    filter: 'dutyFree',
    criteria: (facets: ElasticSearchResponse['facets']['fields']) => booleanFacetCriteria(facets, 'dutyFree'),
  },
  {
    type: HotFilterTypes.CATEGORY,
    label: 'CATALOG.FILTERS.CATEGORY',
    criteria: (facets: ElasticSearchResponse['facets']['fields']) =>
      categoryFilterFacetFields.some((facet) => facets[facet]),
  },
  {
    type: HotFilterTypes.ITEM,
    label: 'CATALOG.FILTERS.BRANDS',
    facet: 'brand',
    searchPlaceholder: 'CATALOG.FILTERS.SEARCH_PLACEHOLDER.BRANDS',
    isSearchable: true,
    sortBy: 'asc',
    filter: 'brand.id',
  },
  {
    type: HotFilterTypes.ITEM,
    label: 'CATALOG.FILTERS.MODELS',
    facet: 'model',
    isSearchable: true,
    sortBy: 'asc',
    filter: 'model.id',
  },
  {
    type: HotFilterTypes.ITEM,
    label: 'CATALOG.FILTERS.CONDITION',
    facet: 'condition',
    sortBy: 'sortById',
    filter: 'condition.id',
  },
  // Top level container for size filters, we always show it because of mysizes
  {
    type: HotFilterTypes.SIZE,
    label: 'CATALOG.FILTERS.SIZES.TITLE',
    criteria: () => true,
  },
  {
    type: HotFilterTypes.ITEM,
    label: 'CATALOG.FILTERS.COLORS',
    facet: 'color',
    sortBy: 'asc',
    filter: 'color.id',
  },
  {
    type: HotFilterTypes.MATERIAL,
    label: 'CATALOG.FILTERS.MATERIALS',
    criteria: (facets: ElasticSearchResponse['facets']['fields']) =>
      materialFilterFacetFields.some((facet) => facets[facet]),
  },
  {
    type: HotFilterTypes.ITEM,
    label: 'CATALOG.FILTERS.LOCATION',
    facet: 'country',
    searchPlaceholder: 'CATALOG.FILTERS.SEARCH_PLACEHOLDER.COUNTRY',
    isSearchable: true,
    sortBy: 'asc',
    filter: 'country',
  },
  {
    type: HotFilterTypes.PRICE,
    label: 'CATALOG.FILTERS.PRICE.INPUT',
    facet: 'price',
    filter: 'price',
  },
  // Express delivery
  {
    type: HotFilterTypes.BOOLEAN,
    label: 'DELIVERY_OPTS.EXPRESS',
    facet: 'stock',
    filter: 'stock',
    criteria: (facets: ElasticSearchResponse['facets']['fields']) => booleanFacetCriteria(facets, 'stock'),
  },
  // Direct shipping
  {
    type: HotFilterTypes.BOOLEAN,
    label: 'CATALOG.FILTERS.DS',
    facet: 'directShippingEligible',
    filter: 'directShippingEligible',
    criteria: (facets: ElasticSearchResponse['facets']['fields']) =>
      booleanFacetCriteria(facets, 'directShippingEligible'),
  },
  {
    type: HotFilterTypes.ITEM,
    label: 'CATALOG.FILTERS.SELLERBADGE',
    facet: 'sellerBadge',
    sortBy: 'asc',
    filter: 'sellerBadge',
  },
  {
    type: HotFilterTypes.ITEM,
    label: 'CATALOG.FILTERS.WATCH_MECHANISM',
    facet: 'watchMechanism',
    filter: 'watchMechanism.id',
  },

  {
    type: HotFilterTypes.ITEM,
    label: 'CATALOG.FILTERS.EDITORPICKS',
    facet: 'editorPicks',
    filter: 'editorPicks',
  },
  {
    type: HotFilterTypes.BOOLEAN,
    label: 'CATALOG.FILTERS.DEALS_ELIGIBLE',
    facet: 'dealEligible',
    filter: 'dealEligible',
    criteria: (facets: ElasticSearchResponse['facets']['fields']) => booleanFacetCriteria(facets, 'dealEligible'),
  },
  {
    type: HotFilterTypes.ITEM,
    label: 'CATALOG.FILTERS.DISCOUNT',
    facet: 'discount',
    filter: 'discount',
  },
  {
    type: HotFilterTypes.BOOLEAN,
    label: 'PRODUCT.DESCRIPTION.BRAND_STORE',
    facet: 'isOfficialStore',
    filter: 'isOfficialStore',
    criteria: (facets: ElasticSearchResponse['facets']['fields']) => booleanFacetCriteria(facets, 'isOfficialStore'),
  },
];
